import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, GraduationCap, ArrowUpRight, ShieldCheck, CircleDot } from 'lucide-react';
import { brand, navItems, founder } from '../mock';

const coreExpertise = [
  'Contractor KPI Auditing',
  'Road Asset Management',
  'TGS & WSTM Review',
  'MASH Barrier Assessment',
  'Program Delivery',
  'Infrastructure Analytics',
];

const Footer = () => {
  return (
    <footer className="border-t border-white/5 bg-[#0a1120]">
      <div className="max-w-[1320px] mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-md bg-[#0f1a2f] border border-white/10 flex items-center justify-center text-orange-400 font-mono text-[13px]">+000</div>
              <div className="flex items-center gap-2">
                <span className="text-white font-serif text-xl">{brand.name}</span>
                <span className="text-[10px] font-mono tracking-[0.18em] text-orange-300">{brand.tag}</span>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              Specialist infrastructure advisory grounded in direct operational experience — delivering contractor performance management, road asset maintenance governance, and technical compliance across Australia.
            </p>
            <div className="mt-5 border border-white/10 rounded-md p-4 bg-white/[0.02]">
              <div className="flex items-center gap-2 text-sm text-slate-200">
                <GraduationCap className="w-4 h-4 text-orange-400" />
                <span className="font-medium">Independent Senior-Led Practice, {founder.credentials}</span>
              </div>
              <p className="text-xs text-slate-500 mt-2 leading-relaxed">{founder.bio}</p>
            </div>
          </div>

          <div>
            <div className="text-[11px] font-mono tracking-[0.2em] text-slate-500 mb-4">NAVIGATION</div>
            <ul className="space-y-2.5">
              {navItems.map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="text-sm text-slate-300 hover:text-orange-300 transition-colors">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[11px] font-mono tracking-[0.2em] text-slate-500 mb-4">CORE EXPERTISE</div>
            <ul className="space-y-2.5">
              {coreExpertise.map((e) => (
                <li key={e} className="text-sm text-slate-300 flex items-center gap-2">
                  <CircleDot className="w-3 h-3 text-orange-400/70" /> {e}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[11px] font-mono tracking-[0.2em] text-slate-500 mb-4 inline-flex items-center gap-2">
              <ShieldCheck className="w-3.5 h-3.5 text-orange-400" /> GEOGRAPHIC SCOPE
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Services are offered to government road authorities, state transport agencies, local councils, and Tier-1 consulting firms across all states in Australia.
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 border border-white/15 hover:border-orange-400/60 rounded-md text-sm text-slate-200 hover:text-orange-300 transition-colors"
            >
              Submit Project Inquiry <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row md:items-center justify-between gap-3 text-xs text-slate-500 font-mono">
          <div>© 2026 Chainage Advisory. All rights reserved. Melbourne, Victoria, Australia.</div>
          <div className="flex items-center gap-4">
            <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {brand.location}</span>
            <span className="text-slate-700">•</span>
            <span className="inline-flex items-center gap-1.5"><Mail className="w-3.5 h-3.5" /> {brand.email}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
